import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Box } from '../Box';
import { Container } from '../Container';
export const Section = (props)=>{
    const { background, children, containerWidth, ...otherProps } = props;
    return /*#__PURE__*/ _jsx(Box, {
        "data-mesh-component": "SECTION",
        padding: {
            xs: 4,
            md: 6,
            lg: 8
        },
        background: background !== null && background !== void 0 ? background : 'transparent',
        ...otherProps,
        children: /*#__PURE__*/ _jsx(Container, {
            width: containerWidth,
            children: children
        })
    });
};
Section.displayName = 'Section';

//# sourceMappingURL=index.js.map